import { render, staticRenderFns } from "./chatSession.vue?vue&type=template&id=6f08365d&scoped=true"
import script from "./chatSession.vue?vue&type=script&lang=js"
export * from "./chatSession.vue?vue&type=script&lang=js"
import style0 from "./chatSession.vue?vue&type=style&index=0&id=6f08365d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f08365d",
  null
  
)

export default component.exports